module.exports = __webpack_public_path__ + "static/media/close.3abf09e4.svg";